import { motion } from 'motion/react'
import { customerMotionTransition } from '../customer-area'
import { joinClassNames, type OrderProgressStep, toneToStepClasses } from './dashboardShared'

type DashboardTrackingProgressProps = {
  selectedOrderProgress: OrderProgressStep[]
  reducedMotion: boolean
}

export const DashboardTrackingProgress = ({ selectedOrderProgress, reducedMotion }: DashboardTrackingProgressProps) => (
  <>
    <div className="relative hidden sm:block">
      <div className="h-1 rounded-full bg-(--color-border-subtle)" />
      <motion.div
        className="absolute inset-y-0 left-0 rounded-full bg-(--color-action-primary)"
        initial={{ width: 0 }}
        animate={{
          width: `${Math.max(
            (selectedOrderProgress.filter(
              (step) => step.tone === 'done' || step.tone === 'current' || step.tone === 'cancelled',
            ).length /
              Math.max(selectedOrderProgress.length, 1)) *
              100,
            8,
          )}%`,
        }}
        transition={customerMotionTransition}
      />
    </div>

    <ol className="space-y-5">
      {selectedOrderProgress.map((step, index) => {
        const stepClasses = toneToStepClasses[step.tone]
        const isLast = index === selectedOrderProgress.length - 1

        return (
          <motion.li
            key={step.id}
            initial={reducedMotion ? { opacity: 0 } : { opacity: 0, x: -6 }}
            animate={reducedMotion ? { opacity: 1 } : { opacity: 1, x: 0 }}
            transition={customerMotionTransition}
            className="relative flex items-start gap-3.5 pl-1"
          >
            <span className="relative mt-0.5 inline-flex h-3.5 w-3.5 shrink-0">
              <motion.span
                className={joinClassNames('inline-flex h-3.5 w-3.5 rounded-full border', stepClasses.dot)}
                animate={step.tone === 'current' && !reducedMotion ? { scale: [1, 1.08, 1] } : { scale: 1 }}
                transition={{ duration: 0.2, ease: customerMotionTransition.ease }}
              />
              {!isLast ? (
                <span
                  className={joinClassNames('absolute left-[6px] top-3.5 h-8 w-px', stepClasses.line)}
                  aria-hidden
                />
              ) : null}
            </span>
            <p className={joinClassNames('text-sm leading-5', stepClasses.title)}>{step.label}</p>
          </motion.li>
        )
      })}
    </ol>
  </>
)
